import NewCustomerPage from './new-customer';
import config from 'config';

export const NewCustomerConfig = {
  routes  : [
    {
      path     : config.pages.store.newCustomer,
      component: NewCustomerPage
    },
  ]
};
